docReady(function(){ 
    function detectorReviews(){
        if(document.querySelectorAll(".yotpo-stars + a").length <= 0)
        {
            setTimeout(function(){ detectorReviews() },200)
        }
        document.querySelectorAll(".yotpo-stars + a").forEach(function(a){ 
            var newNumber=0;
            var regex = /(\d+)/g;
            let text=a.innerHTML;
            let number=text.match(regex);
            if(number >= 1000 && number < 1000000){      
                if(number < 10000)
                {
                    newNumber=String(number).substring(0,1);
                    if(String(number).substring(1,2) != 0)
                    {
                        newNumber+="."+String(number).substring(1,2);
                    }
                }
                else
                {
                    newNumber=String(number).substring(0,2);
                }
                a.innerHTML=newNumber+"K";
            }
            else {
                a.innerHTML=number;
            }
        })
    }
    detectorReviews()

    document.querySelectorAll(".product-grid-item").forEach( function(card){

        var modal = card.querySelector("#custom-modal-plp");

        if(!modal){
        return false
        }

        var btn = card.querySelector("#custom-modal-btn");
        var span = card.querySelector(".close");
        var cart = card.querySelector(".custom-btn-atc");

        btn.addEventListener("click" , function(){
        document.body.appendChild(modal);
        modal.style.display = "block";
        modal.querySelector(".Product-variant-option").click();
        })

        span.addEventListener("click" , function(){
        modal.style.display = "none";
        })

        cart.addEventListener("click" , function(){
        modal.style.display = "none";
        })

    }); 

    window.onclick = function(event) {
        if (!event.target.closest(".modal-content") && !event.target.closest("#custom-modal-btn") ) {
            document.querySelectorAll("#custom-modal-plp").forEach( function(modal){
            modal.style.display = "none";
            })
        }
    }
}); 